import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
    SAVE_QUESTIONS_PROGRESS,
} from '../constants/assessmentSectionQuestions';
import {
    saveQuestionsProgressFailure,
    saveQuestionsProgressSuccess,
} from '../actions/assessmentSectionQuestions';
import Api from '../../utils/api';

function* saveProgress({ form, meta }) {
    const { page, toReports } = meta;
    const {
        actions: {
            resetForm,
            setSubmitting,
        },
        values,
    } = form;
    try {
        const url = `/public/demo/compute/score`;
        const params = {
            page,
        };
        const response = yield call(Api.post, url, {
            data: { options: values },
            params,
        });
        yield call(setSubmitting, false);
        yield call(resetForm);
        const nextStep = response.data;
        yield put(saveQuestionsProgressSuccess(nextStep));
        yield call(toReports(nextStep));
    } catch (error) {
        yield call(setSubmitting, false);
        yield put(saveQuestionsProgressFailure(error));
    }
}

function* assessmentSectionQuestionsSaga() {
    yield all([
        takeLatest(SAVE_QUESTIONS_PROGRESS, saveProgress),
    ]);
}

export default assessmentSectionQuestionsSaga;
